import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle } from 'styles/theme';

export const Wrapper = styled.div`
  
  @media(${breakpoint.lgMin}) {
    display: flex;
    gap: 80px;
    padding: 0 24px;

    & > div {
      max-width: 55%;
    }

    .about-featured {
      flex: 1;
      width: 100%;
    }
  }
`;

export const TextContainer = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' })};

  &.bolded, 
  .bolded {
    font-weight: 600;
    position: relative;
    display: block;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;

  .great-places-link {
    font-size: 14px;
    margin: 16px auto;
  }

  @media (${breakpoint.mdMin}) {
    .great-places-link {
      margin: 48px auto 16px;
    }
  }
`;
